import { FC, useEffect } from 'react';
import { MainWrapper } from './components/main-wrapper/main-wrapper';

export const App: FC = () => {
  return (
    <MainWrapper />
  );
};